module.exports = __webpack_public_path__ + "static/media/walletlink.d8108ec0.svg";